import React from "react";
import Immutable from "immutable";
import { Input, Select, SelectOption, Switch } from "@showitinc/showit-wc";

import AppConstants from "../../../constants/AppConstants";
import BlockSelectInput from "../../../components/BlockSelectInput";
import BlockStateSelectInput from "../../../components/BlockStateSelectInput";
import { formatPropUpdate } from "../../../utils/PropertyUtils";
import { INPUT_TYPE_NUMBER } from "../../../constants/ElementConstants";
import { Action, AddAction } from "../../base/Actions";

const BlockPropertiesActions = ({ onPropUpdate, block, isLocked }) => {
  const scrollActions = block.getIn(["pubs", "scroll"], []);

  const _onPropChange = (propInfo) => {
    if (onPropUpdate) {
      onPropUpdate(propInfo);
    }
  };

  const handleBlockChange = (propInfo) => {
    if (propInfo.value !== propInfo.origValue) {
      const statePropName = propInfo.name.replace(".block", ".state");
      onPropUpdate(formatPropUpdate(statePropName, null, null, AppConstants.UPDATE_ACTION_DELETE));
    }
    onPropUpdate(propInfo);
  };

  const _addAction = () => {
    const propInfo = { name: "pubs" };
    let action = Immutable.Map();
    action = action.set("trigger", AppConstants.BLOCK_TRIGGER_ON_SCREEN);
    action = action.set("type", AppConstants.BLOCK_ACTION_SHOW);

    propInfo.origValue = block.get("pubs", null);

    let pubs = block.get("pubs");
    if (!pubs || !Immutable.Map.isMap(pubs)) {
      pubs = Immutable.Map();
    }

    let scroll = pubs.get("scroll");
    if (!scroll || !Immutable.List.isList(scroll)) {
      scroll = Immutable.List();
    }

    propInfo.action = AppConstants.UPDATE_ACTION_SET; // reset the link object
    scroll = scroll.push(action);
    propInfo.value = pubs.set("scroll", scroll);

    onPropUpdate(propInfo);
  };

  const _removeAction = (propInfo) =>
    _onPropChange({ ...propInfo, action: AppConstants.UPDATE_ACTION_DELETE });

  const _onCheckChange = (propInfo) =>
    _onPropChange({ ...propInfo, value: propInfo.value ? 1 : null });

  return (
    <>
      {scrollActions.map((action, index) => {
        const actionId = `pubs.scroll.${index}`;
        const actionTrigger = action.get("trigger");
        const actionType = action.get("type");
        const actionBlock = action.get("block", "");
        const actionState = action.get("state", "");

        return (
          <Action
            onRemoveAction={() => _removeAction({ name: actionId })}
            key={index}
            index={index}
            isLocked={isLocked}
          >
            <Select
              label="Trigger"
              value={actionTrigger}
              reserveContext
              onSISelect={(e) =>
                _onPropChange(
                  formatPropUpdate(`${actionId}.trigger`, e.target.value, actionTrigger),
                )
              }
              shift="left"
            >
              <SelectOption value={AppConstants.BLOCK_TRIGGER_ON_SCREEN}>On Screen</SelectOption>
              <SelectOption value={AppConstants.BLOCK_TRIGGER_OFF_SCREEN}>Off Screen</SelectOption>
              <SelectOption value={AppConstants.BLOCK_TRIGGER_PERCENT_SCREEN}>
                Percent from Top
              </SelectOption>
            </Select>
            {actionTrigger === AppConstants.BLOCK_TRIGGER_PERCENT_SCREEN && (
              <Input
                type={INPUT_TYPE_NUMBER}
                min="0"
                max="100"
                step="10"
                label="From Top"
                propName={`${actionId}.offset`}
                units="%"
                value={action.get("offset", "50")}
                onSIInput={(e) =>
                  _onPropChange(
                    formatPropUpdate(`${actionId}.offset`, e.target.value, action.get("offset")),
                  )
                }
              />
            )}
            <Select
              label="Action"
              value={actionType}
              reserveContext
              onSISelect={(e) =>
                _onPropChange(formatPropUpdate(`${actionId}.type`, e.target.value, actionType))
              }
              shift="left"
            >
              <SelectOption value={AppConstants.BLOCK_ACTION_SHOW}>Show Canvas</SelectOption>
              <SelectOption value={AppConstants.BLOCK_ACTION_HIDE}>Hide Canvas</SelectOption>
              <SelectOption value={AppConstants.BLOCK_ACTION_CHANGE}>
                Change Canvas View
              </SelectOption>
            </Select>
            <BlockSelectInput
              propName={`${actionId}.block`}
              value={actionBlock}
              label="Canvas"
              onChange={handleBlockChange}
            />
            {actionType === AppConstants.BLOCK_ACTION_CHANGE && (
              <BlockStateSelectInput
                key={`state-select-${actionBlock}`}
                propName={`${actionId}.state`}
                value={actionState}
                onChange={_onPropChange}
                blockSlug={actionBlock}
              />
            )}
            <Switch
              checked={action.get("once", false)}
              label="Trigger Once"
              onClick={(e) =>
                _onCheckChange(
                  formatPropUpdate(`${actionId}.once`, e.target.checked, action.get("once")),
                )
              }
            />
          </Action>
        );
      })}
      <AddAction onAddAction={_addAction} />
    </>
  );
};

export default BlockPropertiesActions;
